<template>
	<Page>
		<template #header>Set password</template>

		<template #default>
			<label>Input new password</label>
			<BaseInput v-model="password" />
		</template>

		<template #footer>
			<BaseButton class="mt-auto" @click="setPassword()">Set password</BaseButton>
		</template>
	</Page>
</template>

<script setup lang="ts">
import Page from '@/components/ui/Page.vue';
import { useWalletStore } from '@/stores/useWalletStore';
import { ref } from 'vue';
import BaseButton from '../ui/BaseButton.vue';
import BaseInput from '../ui/BaseInput.vue';

const wallet = useWalletStore();

const password = ref<string>('');

const setPassword = () => {
	wallet.setPassword(password.value);
	emit('closed', true);
};

const emit = defineEmits<{
	(e: 'closed', result: boolean): any;
}>();
</script>
